<template>
  <div>
    <!-- <payslips></payslips> -->
    <!-- <benefit-info-card :title="payInfoTitle" :data="payInfo"></benefit-info-card> -->
    <!-- <benefit-info-card
      :title="benefitsInfoTitle"
      :data="benefitsInfo"
      itemIndex="1"
      :get_error="get_error"
    ></benefit-info-card> -->
    <Benefits> </Benefits>
    <benefit-info-card
      :title="bankDetailsTitle"
      :data="bankDetailsInfo"
      itemIndex="2"
      :get_error="get_error"
      :reloadBankDetails="reload"
    ></benefit-info-card>
  </div>
</template>

<script>
import BenefitInfoCard from "../benefitInfoCard.vue";
// import InfoCard from "../infoCard.vue";
// import Payslips from "../payslips.vue";
// import BenefitsInfoCard from "../benefitInfoCard.vue";
import Benefits from "@/components/employees/tabs/benefits.vue";

import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "compensationAndBenefits",
  components: {
    BenefitInfoCard,
    Benefits,
    // InfoCard,
    // Payslips,
    // BenefitsInfoCard,
  },
  data() {
    return {
      payInfoTitle: "Payment Information",
      benefitsInfoTitle: "Benefits Details",
      bankDetailsTitle: "Bank Details",
      bankDetails: [],
      employeeBenefits: [],
      tableData: [],
      get_error: null,
      payInfo: [],

      benefitsInfo: [
        {
          name: "Annual Gross Pay",
          value: "1,200,000",
        },
      ],
      bankDetailsInfo: [],
    };
  },
  created() {
    this.getEmployeeBenefitsInfo();
  },
  computed: {
    ...mapGetters(["getOrganization", "getToken", "getCurrentEmployeeId"]),
  },

  methods: {
    reload() {
      this.getEmployeeBenefitsInfo();
    },
    // /{organization}/employee/{employeeId}/compensation/benefit/v1/request
    getEmployeeBenefitsInfo() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/${this.getCurrentEmployeeId}/compensation/benefit/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.tableData = response.data.Data;
              this.bankDetailsInfo = [response.data.Data.bankDetails].map(
                (detail) => ({
                  info: this.formatBankDetailsData(detail),
                })
              );
              this.benefitsInfo = response.data.Data.employeeBenefits.map(
                (benefit) => ({
                  info: this.formatEmployeeBenefitsData(benefit),
                })
              );
              //console.log(this.benefitsInfo)

              const uniqueBenefitIds = new Set();
              const uniqueObjects = [];

              this.benefitsInfo.forEach((obj) => {
                const benefitId = obj.info[0].benefitId;

                if (!uniqueBenefitIds.has(benefitId)) {
                  uniqueBenefitIds.add(benefitId);
                  uniqueObjects.push(obj);
                }
              });
              this.benefitsInfo = uniqueObjects;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    // format benefits data
    formatEmployeeBenefitsData(employeeBenefits) {
      return [
        {
          employeeBenefitsId: employeeBenefits.EmployeeBenefitsId,
          benefitId: employeeBenefits.BenefitId,
          name: "Benefit",
          value: employeeBenefits.BenefitName,
        },
      ];
    },

    // format bank details data
    formatBankDetailsData(bankDetails) {
      return [
        {
          name: "Account Name",
          value: bankDetails.AccountName,
        },
        {
          name: "Account Number",
          value: bankDetails.AccountNumber,
        },

        {
          name: "Name",
          value: bankDetails.BankName,
        },
        {
          name: "Branch",
          value: bankDetails.Branch,
        },
        {
          name: "Branch Code",
          value: bankDetails.BranchCode,
        },

        {
          name: "Swift Code",
          value: bankDetails.SwiftCode,
        },
      ];
    },
  },
};
</script>
